module.controller('dashboardClientCtrl', [ '$scope', '$rootScope', '$state', 'dataIni', dashboardClientCtrlFn ]);

function dashboardClientCtrlFn($scope, $rootScope, $state, dataIni) {
	var vm = $scope;
	
	vm.info = {};

	/**
	 * Se ejecuta al iniciar
	 */
	function init() {
		if (dataIni.status) {
			vm.info = dataIni.response.getData();
		}
	}

	init();
}